// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__3B__j","errorLogs":"EditorFooter_errorLogs__3P9HZ"};